import IconArrow from './icon-arrow'

export default IconArrow
